// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rc-drawer {
  inset: 0;
  position: fixed;
  z-index: 1050;
  pointer-events: none;
}
.rc-drawer-inline {
  position: absolute;
}
.rc-drawer-mask {
  inset: 0;
  position: absolute;
  z-index: 1050;
  background: rgba(0, 0, 0, 0.5);
  pointer-events: auto;
}
.rc-drawer-content-wrapper {
  position: absolute;
  z-index: 1050;
  overflow: hidden;
  transition: transform 0.3s;
}
.rc-drawer-content-wrapper-hidden {
  display: none;
}
.rc-drawer-left .rc-drawer-content-wrapper {
  top: 0;
  bottom: 0;
  left: 0;
}
.rc-drawer-right .rc-drawer-content-wrapper {
  top: 0;
  right: 0;
  bottom: 0;
}
.rc-drawer-content {
  width: 100%;
  height: 100%;
  overflow: auto;
  background: #fff;
  pointer-events: auto;
}
`, "",{"version":3,"sources":["webpack://./node_modules/rc-drawer/assets/index.css"],"names":[],"mappings":"AAAA;EACE,QAAQ;EACR,eAAe;EACf,aAAa;EACb,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,QAAQ;EACR,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,aAAa;AACf;AACA;EACE,MAAM;EACN,SAAS;EACT,OAAO;AACT;AACA;EACE,MAAM;EACN,QAAQ;EACR,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,oBAAoB;AACtB","sourcesContent":[".rc-drawer {\n  inset: 0;\n  position: fixed;\n  z-index: 1050;\n  pointer-events: none;\n}\n.rc-drawer-inline {\n  position: absolute;\n}\n.rc-drawer-mask {\n  inset: 0;\n  position: absolute;\n  z-index: 1050;\n  background: rgba(0, 0, 0, 0.5);\n  pointer-events: auto;\n}\n.rc-drawer-content-wrapper {\n  position: absolute;\n  z-index: 1050;\n  overflow: hidden;\n  transition: transform 0.3s;\n}\n.rc-drawer-content-wrapper-hidden {\n  display: none;\n}\n.rc-drawer-left .rc-drawer-content-wrapper {\n  top: 0;\n  bottom: 0;\n  left: 0;\n}\n.rc-drawer-right .rc-drawer-content-wrapper {\n  top: 0;\n  right: 0;\n  bottom: 0;\n}\n.rc-drawer-content {\n  width: 100%;\n  height: 100%;\n  overflow: auto;\n  background: #fff;\n  pointer-events: auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
